/* eslint-disable no-undef */
import React from "react";
import { Modal } from "react-bootstrap";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { StyledModal } from "../AttendeesModal/styles";
import { Border } from "../Journeys/styles";
import { CommonButtonPopup } from "../ReportsV2/styles";
import { fetchApi } from "../../utils/methods";
import { StartWellnessChallenge } from "../../redux/constants/apiConstants";
import { t } from "i18next";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import { InputContainer, StyledInputV2, StyledLabel } from "../CreateEvent/style";
import { CustomTitle } from "./styles";
import { AdminCloseIcon } from "../../utils/icons";
import { useHistory } from 'react-router-dom';



const ChallengeStartModal = ({ showModal, onHide, challengeId}) => {

  const [goal,setGoal] = React.useState("");
  const history = useHistory();
  

  const submitChallengeStartDate = async (date) => {
    
    try {
      const payload = {
        challenge_id: Number(challengeId),
        challenge_started_date: date, // ensure format
        days: 14,
        goal:goal,
      };
  
      const res = await fetchApi(`${StartWellnessChallenge}`,"POST",payload);
  
      if (res?.status === "success") {
        toast.success(res?.data?.message || "Challenge start date saved!");
        onHide();
        // refreshAnnouncements();
        history.push(`/challenges/wellness-challenge/${challengeId}`);
        // You can close modal or refresh data here
      } else {
        toast.error(res?.data?.message || "Failed to save start date");
      }
    } catch (error) {
      console.error("Error submitting challenge start date:", error);
    }
  };



  const onChangeInput = (e) => {
    setGoal(e.target.value);
  }


  const isGoalValid = goal.trim().length > 0;


  return (
    <StyledModal
      $width={"600px"}
      $height={"auto !important"}
      show={showModal}
      onHide={onHide}
    //   isPadding={"0 16px"}
    >
      {/* Header */}
      <Modal.Header style={{ background: "white", border: "none" }}>
        <CustomTitle>
          <div className="headerContainer">
            <span className="title">{t("Write Your Goal")}</span>
            <div className="closeImage" onClick={onHide}>
              <div onClick={onHide}>{AdminCloseIcon()}</div>
            </div>
          </div>
        </CustomTitle>
      </Modal.Header>

      <Border
        style={{
          width: "93%",
          background: "#EFEFEF",
          margin: "4px 16px 20px 16px",
        }}
      />

      {/* Body */}
      <Modal.Body
        style={{ display: "flex", justifyContent: "center", alignItems: "center",padding:"0 16px" }}
      >
        <InputContainer>
          <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"}>{("Write Your goal here")}{<span>*</span>}</StyledLabel>
          <StyledInputV2
            as="textarea"
            isPadding={"14px 16px"}
            placeholder={("Write a your goal here")}
            name="title"
            onChange={onChangeInput}
            value={goal}
            height={"130px"}
            maxLength="300"
            style={{background:"white"}}
            pColor={"#BDBDBD"}
            color="#184A61"
            border={"1px solid #BDBDBD"}
          />
          <div className="count">{goal?.length}/300 | C</div>
        </InputContainer> 
       
      </Modal.Body>

      {/* Footer */}
      <Modal.Footer
        style={{
          borderTop: "none",
          display: "flex",
          gap: "12px",
          width: "100%",
          justifyContent:"center",
        }}
      >
        <div style={{ display: "flex", justifyContent:"ceter", marginTop: "20px",width:'200px' }}>
          <CommonButtonPopup
            height="40px"
            width="100%"
            disabled={!isGoalValid}
            onClick={() =>
              isGoalValid &&
              submitChallengeStartDate(dayjs().format("YYYY-MM-DD"))
            }
            // onClick={() => submitChallengeStartDate(dayjs().add(1, "day").format("YYYY-MM-DD"))}
          >
            {t("Start my challenge")}
          </CommonButtonPopup>
        </div>
      </Modal.Footer>
    </StyledModal>
  );
};

ChallengeStartModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  challengeId:PropTypes.number,
  refreshAnnouncements:PropTypes.func
};

export default withTranslation()(ChallengeStartModal);
